import lounges from '../icons/groups/lounges.webp'
import concertsPerformances from '../icons/groups/concerts-performances.webp'
import mysticOfTheHorizons from '../icons/groups/mystic-of-the-horizons.webp'
import heavenlyVoices from '../icons/groups/heavenly-voices.webp'
import healthHealing from '../icons/groups/health-healing.webp'
import christmasImpressions from '../icons/groups/christmas-impressions.webp'
import timelessClassics from '../icons/groups/timeless-classics.webp'
import handmadeMusic from '../icons/groups/handmade-music.webp'
import wmfpTest from '../icons/groups/wmfp-test.webp'
import hospitality from '../icons/groups/hospitality.webp'
import animation from '../icons/groups/animation.webp'
import defaultIcon from '../icons/groups/default.webp'

// Groups live in the DB, so icons are matched by a slug of the group title
// ("Concerts & Performances" -> "concerts-performances"). A group without its own
// icon here (a new or renamed one) falls back to the generic icon.
const GROUP_ICONS = {
    'lounges': lounges,
    'concerts-performances': concertsPerformances,
    'mystic-of-the-horizons': mysticOfTheHorizons,
    'heavenly-voices': heavenlyVoices,
    'health-healing': healthHealing,
    'christmas-impressions': christmasImpressions,
    'timeless-classics': timelessClassics,
    'handmade-music': handmadeMusic,
    'wmfp-test': wmfpTest,
    'hospitality': hospitality,
    'animation': animation,
}

const slugify = (title = '') =>
    title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')

export const getGroupIcon = (group) => GROUP_ICONS[slugify(group.title)] || defaultIcon
